
import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import BaseUrl from "../../base-api";
import { toast } from "react-toastify";
import Loader from "../Loader/Loader";
import { FaFilePdf } from "react-icons/fa6";

const Tenders = () => {
  const [loading, setLoading] = useState(false);
  const location = useLocation();
    const [notifications, setNotifications] = useState([]);
    const [viewNotifications, setViewNotifications] = useState([]);

const [searchQuery, setSearchQuery] = useState("");
    useEffect(() => {
        const fetchData = async () => {
          setSearchQuery("");
          setLoading(true);
          try {
           
            const resNote = await axios.post(
              `${BaseUrl}/api/notifications/getNotification`,
              { location: "Tender" },
              {
                headers: { "Content-Type": "application/json" },
              }
            );
    
            if (resNote.data.status === 200) {
              setNotifications(
                resNote.data.data.map((img) => ({
                  id: img.key,
                  title: img.title,
                  file: `data:application/pdf;base64,${img.file}` || "",
                  location: img.location,
                  subDate:img.subDate
                }))
              );
            } else {
              toast.error("Failed to fetch Notifications.");
            }
    
          } catch (error) {
            toast.error(error.response?.data?.message || "An error occurred");
          }
          finally{
            setLoading(false);
          }
        };
    
        if (location.pathname) fetchData();
      }, [location.pathname]);

  useEffect(() => {
    setViewNotifications(notifications);
  }, [notifications]);

      const handleSearch = (e) => {
        const query = e.target.value?.toLowerCase();
        setSearchQuery(query);
    
        const filteredLinks = notifications.filter((link) =>
          link.title?.toLowerCase().includes(query)||
        link.subDate?.toLowerCase().includes(query) 
        
        );
    
        // setTotalItems(filteredLinks.length);
        // setCurrentPage(1);
        setViewNotifications(filteredLinks);
      };
  return (
    <>
    {loading ? (
      <Loader />
    ) : (
    <div className="container my-3">
      <div className="abouts">
        <h5>Tenders <span className="me-2 px-2 bg-dark" style={{float:'right',borderRadius:'5px'}}> <Link to={"/tenders/archived"} style={{color:'white',textDecoration:'none'}}>Archived</Link></span></h5>
      </div>

      <div
        className="about-box p-4 rounded shadow-lg "
        style={{ textAlign: "justify" }}
      >
        <form className="">
          <div className=" text-center mb-2">
            <label htmlFor="" className="mb-2">
              Search Data:
            </label>

            <input
              name="search"
              type="text"
              id="search"
              className=" ms-2 mb-2" style={{border:'1px solid grey'}}
              placeholder="Search by title, date...."
                  value={searchQuery}
                  onChange={handleSearch}
            />
            {/* <button
             className="btn btn-success ms-2"
              id=""
            > Search</button> */}
           <button type="button"
             className="btn btn-danger ms-3"
              onClick={()=>setSearchQuery("")}
            > Reset</button>
          </div>
        </form>
        <div className="table-responsive">
                  <table className="table table-striped table-bordered">
                    <thead>
                      <tr>
                        <th>
                          <span>S.No</span>
                        </th>
                        <th>
                          <span>Tender Related Notices</span>
                        </th>
                        <th>
                          <span>Last Date Of Submission</span>
                        </th>
                        <th>
                          <span>
                            Document{" "}
                            <span style={{ fontSize: "12px" }}>(pdf, English)</span>
                          </span>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {viewNotifications.length>0 ? (
                        viewNotifications?.map((notification,index)=>(
                          <tr key={notification.id}>
                        <td>
                          <span>{index +1}</span>
                        </td>
                        <td>
                          <strong>
                            {notification.title}
                          </strong>
                        </td>
                        <td>
                          <span>{notification.subDate}</span>
                        </td>
                        <td className="text-center align-middle">
                            <a
                                                    href={notification.file}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    download={`${notification.title}.pdf`}
                                                    style={{ textDecoration: "none" }}
                                                  >
                                                                  <FaFilePdf style={{ fontSize: "25px" }} />{" "}
                                                                  </a>
                        </td>
                      </tr>
                        )
                      )
                      ):(
                        <tr>
                        <td colSpan={4} className="text-center">
                        No records found!
                        </td>
                      </tr>
                      )}
                      
        
                     
                    </tbody>
                  </table>
                </div>
      </div>
    </div>
     )}
    </>
  );
};

export default Tenders;
